import { InvestigationFormFieldEntity } from './investigation-form-field.entity';

export class InvestigationFormDetailEntity {
  public id!: string;
  public name!: string;
  public displayName!: string;
  public description!: string;
  public investigationTypeId!: string;
  public investigationTypeName!: string;
  public status!: number;
  public statusName!: 'Draft' | 'Published' | 'Archived';
  public versionId!: string;
  public versionNumber!: number;
  public fields!: InvestigationFormFieldEntity[];
  public createdAt!: Date;
  public updatedAt!: Date;
  public createdBy!: string;
  public updatedBy!: string;
}
